module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.f33df36.eot";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.eot
// module id = 2232
// module chunks = 1